// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container for the portrait grid */
.styled-portraits-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Forzar dos columnas */
  gap: 10px;
  padding: 20px;
  margin: 1cm;
  margin-left: 2px;
  margin-right: 2px;
  grid-auto-rows: auto;
}


/* General image wrapper styling */
.styled-image-wrapper {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: auto;
}

/* Horizontal images occupy the full width */
.horizontal {
  grid-column: span 2; /* Ocupa el ancho completo */
}

/* Thumbnail image styling */
.styled-thumbnail {
  width: 100%;
  height: auto;
  object-fit: cover; /* Ajustar la imagen sin cambiar su proporción */
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.7s ease-in-out, transform 0.7s ease-in-out;
}

.styled-thumbnail.appear {
  opacity: 1;
  transform: translateY(0);
}

/* Enlarged image styling */
.styled-enlarged-image {
  width: 100%; /* Ocupar el 100% del ancho de la pantalla */
  height: auto;
  max-height: 90%; /* Evitar que supere la pantalla */
  object-fit: contain; /* Asegurar que mantenga la proporción */
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  transition: transform 0.5s ease-in-out;
}

/* Overlay background when image is enlarged */
.styled-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Navigation buttons for enlarged image */
.nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
  z-index: 1001;
  font-size: 2rem;
  -webkit-user-select: none;
          user-select: none;
}

.prev-button {
  left: 10px;
}

.next-button {
  right: 10px;
}

.nav-button:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

/* Mobile version */
@media (max-width: 768px) {
  .styled-portraits-container {
    grid-template-columns: 1fr; /* Cambia a 1 columna en móviles */
    gap: 5px; /* Espacio más pequeño entre imágenes */
    padding: 5px;
    margin: 0.2cm;
  }  

  .horizontal {
    grid-column: span 1; /* En móviles, las imágenes horizontales no ocuparán todo el ancho */
  }

  .styled-thumbnail {
    width: 100%; /* Mantener el 100% del ancho */
    height: auto;
    object-fit: cover;
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.7s ease-in-out, transform 0.7s ease-in-out;
  }

  .styled-enlarged-image {
    width: 100%; /* Ocupar el 100% del ancho en móviles */
    max-height: 85%; /* Ajustar el alto máximo */
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .nav-button {
    font-size: 1.5rem; /* Reducir el tamaño de las flechas en móviles */
    padding: 8px; /* Ajustar padding de las flechas */
  }

  .prev-button {
    left: 5px; /* Ajustar posición de la flecha izquierda */
  }

  .next-button {
    right: 5px; /* Ajustar posición de la flecha derecha */
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Tasty.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,aAAa;EACb,qCAAqC,EAAE,wBAAwB;EAC/D,SAAS;EACT,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;;AAGA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA,4CAA4C;AAC5C;EACE,mBAAmB,EAAE,4BAA4B;AACnD;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE,gDAAgD;EACnE,UAAU;EACV,2BAA2B;EAC3B,gEAAgE;AAClE;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE,WAAW,EAAE,4CAA4C;EACzD,YAAY;EACZ,eAAe,EAAE,kCAAkC;EACnD,mBAAmB,EAAE,wCAAwC;EAC7D,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sCAAsC;AACxC;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA,mBAAmB;AACnB;EACE;IACE,0BAA0B,EAAE,kCAAkC;IAC9D,QAAQ,EAAE,uCAAuC;IACjD,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,mBAAmB,EAAE,oEAAoE;EAC3F;;EAEA;IACE,WAAW,EAAE,+BAA+B;IAC5C,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,2BAA2B;IAC3B,gEAAgE;EAClE;;EAEA;IACE,WAAW,EAAE,wCAAwC;IACrD,eAAe,EAAE,2BAA2B;IAC5C,QAAQ;IACR,SAAS;IACT,gCAAgC;EAClC;;EAEA;IACE,iBAAiB,EAAE,gDAAgD;IACnE,YAAY,EAAE,mCAAmC;EACnD;;EAEA;IACE,SAAS,EAAE,4CAA4C;EACzD;;EAEA;IACE,UAAU,EAAE,0CAA0C;EACxD;AACF","sourcesContent":["/* Container for the portrait grid */\n.styled-portraits-container {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr); /* Forzar dos columnas */\n  gap: 10px;\n  padding: 20px;\n  margin: 1cm;\n  margin-left: 2px;\n  margin-right: 2px;\n  grid-auto-rows: auto;\n}\n\n\n/* General image wrapper styling */\n.styled-image-wrapper {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  height: auto;\n}\n\n/* Horizontal images occupy the full width */\n.horizontal {\n  grid-column: span 2; /* Ocupa el ancho completo */\n}\n\n/* Thumbnail image styling */\n.styled-thumbnail {\n  width: 100%;\n  height: auto;\n  object-fit: cover; /* Ajustar la imagen sin cambiar su proporción */\n  opacity: 0;\n  transform: translateY(20px);\n  transition: opacity 0.7s ease-in-out, transform 0.7s ease-in-out;\n}\n\n.styled-thumbnail.appear {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* Enlarged image styling */\n.styled-enlarged-image {\n  width: 100%; /* Ocupar el 100% del ancho de la pantalla */\n  height: auto;\n  max-height: 90%; /* Evitar que supere la pantalla */\n  object-fit: contain; /* Asegurar que mantenga la proporción */\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1000;\n  transition: transform 0.5s ease-in-out;\n}\n\n/* Overlay background when image is enlarged */\n.styled-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.8);\n  z-index: 999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Navigation buttons for enlarged image */\n.nav-button {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white;\n  border: none;\n  padding: 10px;\n  cursor: pointer;\n  z-index: 1001;\n  font-size: 2rem;\n  user-select: none;\n}\n\n.prev-button {\n  left: 10px;\n}\n\n.next-button {\n  right: 10px;\n}\n\n.nav-button:hover {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n\n/* Mobile version */\n@media (max-width: 768px) {\n  .styled-portraits-container {\n    grid-template-columns: 1fr; /* Cambia a 1 columna en móviles */\n    gap: 5px; /* Espacio más pequeño entre imágenes */\n    padding: 5px;\n    margin: 0.2cm;\n  }  \n\n  .horizontal {\n    grid-column: span 1; /* En móviles, las imágenes horizontales no ocuparán todo el ancho */\n  }\n\n  .styled-thumbnail {\n    width: 100%; /* Mantener el 100% del ancho */\n    height: auto;\n    object-fit: cover;\n    opacity: 0;\n    transform: translateY(20px);\n    transition: opacity 0.7s ease-in-out, transform 0.7s ease-in-out;\n  }\n\n  .styled-enlarged-image {\n    width: 100%; /* Ocupar el 100% del ancho en móviles */\n    max-height: 85%; /* Ajustar el alto máximo */\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  .nav-button {\n    font-size: 1.5rem; /* Reducir el tamaño de las flechas en móviles */\n    padding: 8px; /* Ajustar padding de las flechas */\n  }\n\n  .prev-button {\n    left: 5px; /* Ajustar posición de la flecha izquierda */\n  }\n\n  .next-button {\n    right: 5px; /* Ajustar posición de la flecha derecha */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
